import { ModuleCorePermissionProps, PermissionsScheme } from '@/config/types';
import { usePermissionsModule } from '@/hooks/usePermissionsModule';

// T represents the non-editable module props
// U represents the editable module props
// This generic approach makes "edit" prop in permissions compulsory if the module is editable

export function withPermissionsModule<T extends unknown | ModuleCorePermissionProps>(Module: React.ComponentType<T>) {
  return ({
    permissions,
    ...props
  }:
    | (T & { permissions: PermissionsScheme })
    | (Omit<T, 'canEdit'> & { permissions: Required<PermissionsScheme> })): React.ReactElement<T> | null => {
    const { canView, canEdit, userType, userRoles } = usePermissionsModule(permissions);

    if (!canView || !userType || !userRoles) return null;

    const moduleProps = {
      ...props,
      ...(canEdit !== null && { canEdit }),
      userType,
      userRoles,
    } as React.PropsWithChildren<T>;

    return <Module {...moduleProps} />;
  };
}
